import AppLoading from '@/components/AppLoading';
import useLiveTags from '../tags/useLive';
import useTagsStore from '../tags/useStore';
import useLiveActivities from './activities/useLive';
import useActivitiesStore from './activities/useStore';
import useLiveProcesses from './processes/useLive';
import useProcessesStore from './processes/useStore';
import useLiveProperties from './properties/useLive';
import usePropertiesStore from './properties/useStore';
import useLiveSkills from './skills/useLive';
import useSkillsStore from './skills/useStore';

const LibraryObserver = ({ children }) => {
  const isLoading =
    useActivitiesStore((state) => state.isActivitiesLoading) ||
    useProcessesStore((state) => state.isProcessesLoading) ||
    usePropertiesStore((state) => state.isPropertiesLoading) ||
    useSkillsStore((state) => state.isSkillsLoading) ||
    useTagsStore((state) => state.isTagsLoading);

  useLiveActivities();
  useLiveProcesses();
  useLiveProperties();
  useLiveSkills();
  useLiveTags();

  if (isLoading) {
    return (
      <AppLoading
        reason="LibraryObserver.isLoading"
        messages={['Pulling up your account...', '⚡ Almost ready to roll!']}
      />
    );
  }

  return children;
};

export default LibraryObserver;
